var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.topClassName},[_c('app-navigation'),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_vm._v(" "),_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }